import React, { useEffect, useState, useContext, useRef } from 'react';
import Breadcrumbs from '../../../../components/commonLayouts/Breadcrumbs/BreadCrumb';
import { useNavigate } from 'react-router-dom';
import { Formik, Form } from 'formik';
import Button from '../../../../components/formInputs/button/Button';
import { useDispatch, useSelector } from 'react-redux';
import AuthContext from '../../../../store/AuthContext';
import {
    getAllAgents,
    getAllBrokers,
    getAllPorts,
    getAllUserBuyer,
    getAllVessels,
    getAllVesselsSupplier,
    getLiveprice,
    productsforbroker,
    getAllSuppliersForPort,
} from '../../../../redux/actions/rfqManagementApi';
import { dealfinancing, platformCharges } from '../../../../redux/actions/transactionApi';
import DealDetails from './components/DealDetails';
import ProductDetails from './components/ProductDetails';
import AdditionalCharges from './components/AdditionalCharges';
import AgentDetails from './components/AgentDetails';
import UploadDocuments from './components/UploadDocuments';
import ExtendedCreditAndServices from './components/ExtendedCreditAndServices';
import FinancingType from './components/FinancingType';
import { DropdownConstants } from '../../../../utils/constants/DropDownConstants';
import { getOrganizationDetails } from '../../../../redux/actions/userManagementApi';
import DataModal from '../../../../components/modals/dataModal/DataModal';
import {
    getOrgUlid,
    getPaymentTermDays,
    getFinancingOptionVariable,
    getCreditOptFromFinancingOption,
    computeCreditDaysInterest,
    formatCalculatedDealValue,
    shouldAbortBrokerSubmit,
    appendFocDocuments,
    buildDealFinancingPayload,
    getValidationSchemaForRole,
} from './RequestFinancing.helpers';

const RequestFinancing = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const formRef = useRef(null);
    const ctx = useContext(AuthContext);
    console.log('ctx.userData', ctx);

    const orgUlid = getOrgUlid(ctx);
    const { rfqMang } = useSelector((state) => {
        return state.app;
    });

    const state = useSelector((state) => {
        return state.app;
    });
    const [isLoader, setIsLoader] = useState(false);
    const [emailSelectedFiles, setEmailSelectedFiles] = useState([]);
    const [selectedBroker, setSelectedBroker] = useState(null);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [supplierList, setSupplierList] = useState();
    const [productTypes, setProductsTypes] = useState();
    const [tradeCost, setTradeCost] = useState(0);
    const [disputeClaimCost, setDisputeClaimCost] = useState(0);
    const [totalDealVal, setTotalDealVal] = useState();
    const [platformFees] = useState([]);
    const [, setErrorMsg] = useState('');
    const [selectedBuyerName, setSelectedBuyerName] = useState('');
    const [tot, setTot] = useState(0);
    const [prod, setProd] = useState([]);
    const [errorImo, setErrorImo] = useState(false);
    let routes = [
        { path: '/', breadcrumb: 'Home' },
        { path: '/buyerRequestFinancing', breadcrumb: 'Request Financing' },
    ];
    const initialStartDate = new Date();
    initialStartDate.setHours(0, 0, 0, 0);

    const initialEndDate = new Date();
    initialEndDate.setHours(0, 0, 0, 0);
    const initialRequestFinancing = {
        financing_type: 'deal_financing',
        vessel_imo: '',
        vessel_ulid: null,
        port: null,
        delivery_start_date: initialStartDate,
        delivery_end_date: initialEndDate,
        payment_term: '30_days',
        next_port: [],
        delivery_mode: '',
        buyer_supplier_name:
            ctx.userData.user_organizations[0].user_org_role_maps[0].platform_role === 'buyer' ||
            ctx.userData.user_organizations[0].user_org_role_maps[0].platform_role === 'broker'
                ? ''
                : [],
        products: [
            {
                rowKey: 'product-row-0',
                name: '',
                type: '',
                min_volume: '',
                volume: '',
                price: '',
                priceAfterCrdit: 0,
                margin: 0,
                commission: 0,
                commission_type: '',
                creditDaysInterest: 0,
            },
        ],
        additional_charges: [
            {
                rowKey: 'additional-charge-0',
                product_name: '',
                charge_type: '',
                charge_amount: '',
                product_ulid: '',
                other_charge_name: '',
            },
        ],
        assign_broker: '',
        assign_agent: '',
        foc_doc: emailSelectedFiles,
        doc_description: '',
        extended_credit_option: 'not_needed',
        early_payment_options: '3_days',
        services: [],
        settle_exceeded_credit: 'not_needed',
        deal_specific_agreements: '',
        role: ctx.userData.user_organizations[0].user_org_role_maps[0].platform_role,
    };
    useEffect(() => {
        if (!ctx.isSessionReady) return;
        const payload = { port_ulid: null };
        dispatch(getLiveprice(payload));
    }, [ctx.isSessionReady, dispatch]);
    const [localDealCalculation, setLocalDealCalculation] = useState(null);

    useEffect(() => {
        setLocalDealCalculation(state.transaction?.dealCalculation);
    }, [state.transaction?.dealCalculation]);
    const handleBrokerChange = (event) => {
        const selectedBrokerId = event.target.value;
        const broker = rfqMang.allBrokers.find((broker) => broker.ulid === selectedBrokerId);
        setSelectedBroker(broker);
    };
    const handleAgentChange = (event) => {
        const selectedAgentId = event.target.value;
        const agent = rfqMang.allAgents.find((agent) => agent.ulid === selectedAgentId);
        setSelectedAgent(agent);
    };

    const handlePortChange = (portUlid) => {
        dispatch(getAllSuppliersForPort(portUlid[0]?.ulid));
        if (ctx.userData.user_organizations[0].user_org_role_maps[0].platform_role === 'broker') {
            const payload = {
                broker_user_ulid: ctx?.userData?.user_ulid,
                buyer_organization_ulid: ctx.associatedBuyer,
                port_ulid: portUlid[0]?.ulid,
            };
            dispatch(productsforbroker(payload));
        }
    };
    const handleBuyerChange = (buyerUlid) => {
        buyerUlid && dispatch(getAllVessels(buyerUlid));
    };
    const handleVessleIMOChange = (a, option, formikProps, form) => {
        const imoRegex = /^\d{7}$/;
        if (!imoRegex.test(a)) {
            setErrorImo(true);
            form.setFieldError('vessel_imo', 'IMO number must be exactly 7 digits');
        } else {
            setErrorImo(false);
            form.setFieldValue('vessel_imo', a);
            formikProps.setFieldValue('vessel_ulid', option?.ulid);
        }
    };

    const [buyerTradeLimit, setBuyerTradeLimit] = useState();
    const calculateTotalDealValue = (values) => {
        const platformRole = ctx.userData.user_organizations[0].user_org_role_maps[0].platform_role;
        const paymentTermVar = getPaymentTermDays(values.payment_term);
        const optionVariable = getFinancingOptionVariable(platformRole, values);
        const creditOpt = getCreditOptFromFinancingOption(optionVariable);
        const creditDaysInterest = computeCreditDaysInterest({
            creditOpt,
            optionVariable,
            platformRole,
            values,
            organizationDetails: state?.userMang?.organizationDetails,
            platformCharges: state.transaction?.platformCharges,
            setBuyerTradeLimit,
        });
        return formatCalculatedDealValue({
            values,
            platformRole,
            creditDaysInterest,
            creditOpt,
            paymentTermVar,
            optionVariable,
            organizationDetails: state?.userMang?.organizationDetails,
            transaction: state.transaction,
            setTot,
            setProd,
            setTradeCost,
            setDisputeClaimCost,
            setTotalDealVal,
        });
    };

    const handleSubmit = async (values) => {
        setIsLoader(true);
        const platformRole = ctx.userData.user_organizations[0].user_org_role_maps[0].platform_role;
        if (
            shouldAbortBrokerSubmit({
                platformRole,
                totalDealVal,
                buyerTradeLimit,
                localDealCalculation,
                setErrorMsg,
            })
        ) {
            return;
        }
        if (errorImo === true) {
            return;
        }
        const formData = new FormData();
        const documentUlids = appendFocDocuments(values.foc_doc, formData);
        const payload = buildDealFinancingPayload({
            values,
            ctx,
            platformRole,
            documentUlids,
            totalDealVal,
        });
        formData.append('request', JSON.stringify(payload));
        dispatch(dealfinancing(formData));

        navigate('/dashboard?type=payable');
    };
    useEffect(() => {
        if (!ctx.isSessionReady) return;
        if (orgUlid) {
            if (ctx.userData.user_organizations[0].user_org_role_maps[0].platform_role === 'broker') {
                dispatch(getAllVessels(ctx.associatedBuyer));
            } else if (ctx.userData.user_organizations[0].user_org_role_maps[0].platform_role === 'supplier') {
                dispatch(getAllVesselsSupplier(orgUlid));
            } else {
                dispatch(getAllVessels(orgUlid));
            }

            dispatch(getAllAgents(orgUlid));
            dispatch(getAllBrokers(orgUlid));
            let payload = { organization_ulid: orgUlid };
            dispatch(getOrganizationDetails(payload));
        }
        const req = {
            params: null,
            isLoadMore: false,
        };
        dispatch(getAllPorts(req));
        dispatch(platformCharges());
        if (
            ctx.userData.user_organizations[0].user_org_role_maps[0].platform_role === 'buyer' ||
            ctx.userData.user_organizations[0].user_org_role_maps[0].platform_role === 'broker'
        ) {
            dispatch(getAllUserBuyer());
        } // eslint-disable-next-line
    }, [orgUlid, dispatch, ctx.userData.user_organizations, ctx.isSessionReady]);
    useEffect(() => {
        if (ctx.userData.user_organizations[0].user_org_role_maps[0].platform_role === 'broker') {
            setProductsTypes(state.rfqMang.productListForBroker);
        } else {
            setProductsTypes(state.rfqMang.livePrice);
        }

        setSupplierList(state.rfqMang.allSuppliersForPort);
    }, [state.rfqMang, ctx.userData.user_organizations]);

    return (
        <>
            {isLoader === true ? (
                <DataModal
                    modalType='requestFinancing'
                    title='api is updating.....'
                    type={'dataModal-sm'}
                    isFormValidation={false}
                />
            ) : (
                <>
                    <div className='col-12 px-5 mt-4'>
                        <Breadcrumbs routes={routes} />
                        <p className='font-dh4 font-semiBold text-start mb-0'>
                            {' '}
                            <i
                                className='bi bi-arrow-left me-3 cursor'
                                onClick={() => navigate('/dashboard?type=payable')}></i>{' '}
                            Request Financing
                        </p>
                        <div className='clearfix'></div>
                    </div>

                    <div className='row m-0'>
                        <div className='col-12 px-2 px-lg-5 mt-4 '>
                            <Formik
                                innerRef={formRef}
                                initialValues={initialRequestFinancing}
                                onSubmit={async (values, actions) => {
                                    handleSubmit(values);
                                }}
                                validateOnChange={true}
                                validateOnBlur={true}
                                validationSchema={getValidationSchemaForRole(
                                    ctx.userData.user_organizations[0].user_org_role_maps[0].platform_role
                                )}>
                                {(formikProps) => (
                                    <Form>
                                        <div className='bg-white radius8 p-3 '>
                                            <div className='row m-0 bg-white radius5'>
                                                <div className='col-12 p-0'>
                                                    <FinancingType />
                                                </div>

                                                <div className='col-12'>
                                                    <div
                                                        className='accordion accordion-flush'
                                                        id='accordionFlushExample'>
                                                        <DealDetails
                                                            allVesselsSup={rfqMang.allVesselsSupplier}
                                                            allVessels={rfqMang.allVessels}
                                                            role={
                                                                ctx.userData.user_organizations[0].user_org_role_maps[0]
                                                                    .platform_role
                                                            }
                                                            associatedBuyer={ctx.associatedBuyer}
                                                            id={
                                                                ctx.userData.user_organizations[0].user_org_role_maps[0]
                                                                    .organization_ulid
                                                            }
                                                            handlePortChange={handlePortChange}
                                                            supplierList={supplierList}
                                                            formikProps={formikProps}
                                                            handleVessleIMOChange={handleVessleIMOChange}
                                                            handleBuyerChange={handleBuyerChange}
                                                            setSelectedBuyerName={setSelectedBuyerName}
                                                        />
                                                        <ProductDetails
                                                            formikProps={formikProps}
                                                            productTypes={productTypes}
                                                            platformRole={
                                                                ctx.userData.user_organizations[0].user_org_role_maps[0]
                                                                    .platform_role
                                                            }
                                                            associatedBuyer={ctx.associatedBuyer}
                                                            brokerType={ctx.userData.user_organizations[0].broker_type}
                                                            orgId={
                                                                ctx.userData.user_organizations[0].user_org_role_maps[0]
                                                                    .organization_ulid
                                                            }
                                                        />
                                                        <AdditionalCharges
                                                            formikProps={formikProps}
                                                            DropdownConstants={DropdownConstants}
                                                            productTypes={productTypes}
                                                            orgId={
                                                                ctx.userData.user_organizations[0].user_org_role_maps[0]
                                                                    .organization_ulid
                                                            }
                                                            associatedBuyer={ctx.associatedBuyer}
                                                            platformRole={
                                                                ctx.userData.user_organizations[0].user_org_role_maps[0]
                                                                    .platform_role
                                                            }
                                                        />
                                                        <AgentDetails
                                                            rfqMang={rfqMang}
                                                            handleBrokerChange={handleBrokerChange}
                                                            selectedBroker={selectedBroker}
                                                            formikProps={formikProps}
                                                            handleAgentChange={handleAgentChange}
                                                            selectedAgent={selectedAgent}
                                                        />
                                                        <UploadDocuments
                                                            formikProps={formikProps}
                                                            setEmailSelectedFiles={setEmailSelectedFiles}
                                                            emailSelectedFiles={emailSelectedFiles}
                                                        />
                                                        <ExtendedCreditAndServices
                                                            formikProps={formikProps}
                                                            productTypes={productTypes}
                                                            calculateTotalDealValue={calculateTotalDealValue}
                                                            tradeCost={tradeCost}
                                                            disputeClaimCost={disputeClaimCost}
                                                            associatedBuyer={ctx.associatedBuyer}
                                                            totalDealVal={totalDealVal}
                                                            role={
                                                                ctx.userData.user_organizations[0].user_org_role_maps[0]
                                                                    .platform_role
                                                            }
                                                            roleType={ctx.userData.user_organizations[0].broker_type}
                                                            platformFees={platformFees}
                                                            tot={tot}
                                                            prod={prod}
                                                            buyerTradeLimit={buyerTradeLimit}
                                                            allBuyer={rfqMang.allBuyer}
                                                            supplierName={ctx.userData.user_organizations[0].name}
                                                            selectedBuyerName={selectedBuyerName}
                                                            dealData={localDealCalculation}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-12 py-3 mb-4 mt-3 text-start'>
                                            <Button type='primary-sm' btnType='submit'>
                                                Submit
                                            </Button>
                                            <span className='px-2'></span>
                                            <Button type='hollow-gray-sm' onClick={() => navigate('/dashboard')}>
                                                Cancel
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </>
            )}{' '}
        </>
    );
};

export default RequestFinancing;
